import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import MakePayment from './MakePayment';
import PaymentComplete from './PaymentComplete';
import HomePage from './Home';

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/makepayment/:transactionid" element={<MakePayment />} />
          <Route exact path="/paymentcomplete" element={<PaymentComplete />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
